import { apiService } from "api/apiService";
import type {
  TeacherPortfolioTagResource,
  PublicPortfolioTagResource,
} from "api/generated";
import { teacherTagFromDto, publicTagFromDto } from "portfolio/api/mappers";
import type { TeacherTag, BaseTag } from "portfolio/types";

export const fetchPortfolioTags = async (
  options: { archived?: boolean } = {},
): Promise<TeacherTag[]> => {
  const params = options.archived === true ? "?archived=true" : "";
  const {
    data: { data: tags },
  } = await apiService.get<{ data: TeacherPortfolioTagResource[] }>(
    `api/portfolio/tags${params}`,
  );

  return tags.map(teacherTagFromDto);
};

export const updateTag = async (
  tagId: number,
  data: { name: string },
): Promise<TeacherTag> => {
  const { data: tag } = await apiService.put<TeacherPortfolioTagResource>(
    `api/portfolio/tags/${tagId}`,
    data,
  );

  return teacherTagFromDto(tag);
};

export const archiveTag = async (tagId: number): Promise<TeacherTag> => {
  const { data: tag } = await apiService.put<TeacherPortfolioTagResource>(
    `api/portfolio/tags/${tagId}/archive`,
  );

  return teacherTagFromDto(tag);
};

export const restoreTag = async (tagId: number): Promise<TeacherTag> => {
  const { data: tag } = await apiService.put<TeacherPortfolioTagResource>(
    `api/portfolio/tags/${tagId}/restore`,
  );

  return teacherTagFromDto(tag);
};

export const connectTagEducationLevels = async (
  tagId: number,
  educationLevels: string[],
): Promise<TeacherTag> => {
  const { data: tag } = await apiService.post<TeacherPortfolioTagResource>(
    `api/portfolio/tags/${tagId}/connect-education-levels`,
    { education_levels: educationLevels },
  );

  return teacherTagFromDto(tag);
};

export const fetchPublicPortfolioTags = async (): Promise<BaseTag[]> => {
  const {
    data: { data: tags },
  } = await apiService.get<{ data: PublicPortfolioTagResource[] }>(
    "/api/public-portfolio-tags",
  );

  return tags.map(publicTagFromDto);
};
